// SPDX-License-Identifier: AGPL-3.0-or-later

import {Switch} from '@app/features/ui/components/form/FormSwitch';
import UserSettings from '@app/features/user/state/UserSettings';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
import {useCallback} from 'react';

const STRIP_TRACKING_PARAMETERS_FROM_URLS_DESCRIPTOR = msg({
	message: 'Strip tracking parameters from URLs',
	comment: 'Label in the links tab.',
});
const AUTOMATICALLY_REMOVE_TRACKING_PARAMETERS_LIKE_UTM_SOURCE_FBCLID_DESCRIPTOR = msg({
	message:
		'Automatically remove tracking parameters (like utm_source, fbclid, gclid) from URLs in messages you send. Cleans the link before it reaches anyone else.',
	comment: 'Description text in the links tab. Keep the tone plain and specific.',
});
interface LinkSwitchControlProps {
	compact?: boolean;
}

export const StripTrackingParametersControl: React.FC<LinkSwitchControlProps> = observer(({compact = false}) => {
	const {i18n} = useLingui();
	const sanitizeUrls = UserSettings.getSanitizeUrls();
	const label = i18n._(STRIP_TRACKING_PARAMETERS_FROM_URLS_DESCRIPTOR);
	const handleSanitizeUrlsChange = useCallback((value: boolean) => {
		void UserSettings.setSanitizeUrls(value);
	}, []);
	return (
		<Switch
			ariaLabel={label}
			label={compact ? undefined : label}
			description={
				compact ? undefined : i18n._(AUTOMATICALLY_REMOVE_TRACKING_PARAMETERS_LIKE_UTM_SOURCE_FBCLID_DESCRIPTOR)
			}
			value={sanitizeUrls}
			onChange={handleSanitizeUrlsChange}
			compact={compact}
			data-flx="user.chat-settings-tab.links-tab.links-tab-content.switch.sanitize-urls-change"
		/>
	);
});

export const LinksTabContent: React.FC = observer(() => {
	return (
		<StripTrackingParametersControl data-flx="user.chat-settings-tab.links-tab.links-tab-content.strip-tracking" />
	);
});
